(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var root = document.documentElement;
  var switcher = document.querySelector('[data-mode-switch]');
  var searchModal = document.querySelector('[data-search-modal]');
  var searchOpen = document.querySelector('[data-search-open]');
  var searchInput = document.querySelector('[data-search-input]');
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function getSavedMode() {
    try {
      return localStorage.getItem('aurelia-color-mode') || 'light';
    } catch (error) {
      return 'light';
    }
  }

  function saveMode(mode) {
    try {
      localStorage.setItem('aurelia-color-mode', mode);
    } catch (error) {}
  }

  function setMode(mode) {
    var nextMode = mode === 'dark' ? 'dark' : 'light';
    root.setAttribute('data-color-mode', nextMode);
    saveMode(nextMode);
    document.querySelectorAll('[data-mode-choice]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-mode-choice') === nextMode ? 'true' : 'false');
    });
  }

  function setModePanel(open) {
    if (!switcher) return;
    var trigger = switcher.querySelector('[data-mode-trigger]');
    var panel = switcher.querySelector('[data-mode-panel]');
    if (!trigger || !panel) return;
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setSearch(open) {
    if (!searchModal || !searchOpen) return;
    searchModal.hidden = !open;
    root.classList.toggle('search-is-open', open);
    searchOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && searchInput) {
      window.setTimeout(function () { searchInput.focus(); }, 50);
    }
  }

  function setMobileMenu(open) {
    if (!mobileToggle || !mobileNav) return;
    mobileNav.hidden = !open;
    mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('mobile-nav-is-open', open);
  }

  setMode(getSavedMode());

  if (switcher) {
    var trigger = switcher.querySelector('[data-mode-trigger]');
    var close = switcher.querySelector('[data-mode-close]');
    var panel = switcher.querySelector('[data-mode-panel]');

    if (trigger && panel) {
      trigger.addEventListener('click', function () { setModePanel(panel.hidden); });
    }
    if (close && trigger) {
      close.addEventListener('click', function () { setModePanel(false); trigger.focus(); });
    }
    switcher.querySelectorAll('[data-mode-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        setMode(button.getAttribute('data-mode-choice'));
        setModePanel(false);
      });
    });
  }

  if (searchOpen && searchModal) {
    searchOpen.addEventListener('click', function () {
      setModePanel(false);
      setMobileMenu(false);
      setSearch(true);
    });
    searchModal.querySelectorAll('[data-search-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        setSearch(false);
        searchOpen.focus();
      });
    });
  }

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var shouldOpen = mobileNav.hidden;
      setModePanel(false);
      setSearch(false);
      setMobileMenu(shouldOpen);
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setMobileMenu(false); });
    });
  }

  document.addEventListener('click', function (event) {
    if (switcher && !switcher.contains(event.target)) setModePanel(false);
    if (mobileNav && mobileToggle && !mobileNav.hidden && !mobileNav.contains(event.target) && !mobileToggle.contains(event.target)) {
      setMobileMenu(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setModePanel(false);
      setSearch(false);
      setMobileMenu(false);
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990) setMobileMenu(false);
  });
})();
